export const appName = 'reports';
